import React, { ReactNode, useState } from "react"
import { Grid, Tooltip, Typography } from "@material-ui/core"

import {
	ReportProblemOutlined as WarningIcon,
	Close as CloseIcon,
	CheckBox as CheckBoxIcon
} from "@material-ui/icons"

import { ActionDialog, Notification } from "@/components"

import ErrorHandlerService from "@/services/ErrorHandler"

import { ErrorType } from "@/hooks/useValidation"

import useStyles from "@/pages/Admin/ClientCatalog/BlockContactDialog/styles"
import { colors } from "@/styles/colors"
import WABAContactService from "@/@integrations/WABA/services/WABAContactService"

type BlockContactDialogProps = {
	children: ReactNode
	clientId: number
	inboxChannelId: number
	hasTooltip?: boolean
	disabled?: boolean
	onSuccess?: () => void
}

const BLOCK_CONTACT_WARNINGS: string[] = [
	"Ele será removido do bot",
	"Será removido de todos os agendamentos de envio em massa",
	"Se houver um atendimento em aberto, ele será encerrado",
	"As mensagens na fila para esse contato não serão enviadas",
	"O contato será removido dos funis que estiver inserido"
]

const BlockContactDialog: React.FC<BlockContactDialogProps> = (props) => {
	const {
		children,
		clientId,
		inboxChannelId,
		hasTooltip,
		disabled,
		onSuccess
	} = props

	const classes = useStyles()

	const [openDialog, setOpenDialog] = useState(false)

	const handleOpenDialog = async () => {
		setOpenDialog(true)
	}

	const handleCloseDialog = () => {
		setOpenDialog(false)
	}

	const handleBlockContact = async () => {
		try {
			await WABAContactService.blockWabaContact({
				clientId,
				inboxChannelId
			})
			onSuccess?.()
			handleCloseDialog()
		} catch (error) {
			ErrorHandlerService.handle(error as ErrorType)

			Notification.error({
				message: "Erro ao bloquear contato"
			})
			handleCloseDialog()
		}
	}

	return (
		<>
			{
				<Tooltip
					title= {hasTooltip ? "Atenção: na WABA, só é posssível bloquear contatos que te enviaram mensagem nas últimas 24 horas." : ""}
				>
					<Grid
						onClick={disabled ? undefined : handleOpenDialog}
					>
						{children}
					</Grid>
				</Tooltip>
			}

			<ActionDialog
				fullWidth
				openDialog={openDialog}
				onClose={handleCloseDialog}
				title={"ATENÇÃO"}
				dialogTitleIcon={<WarningIcon className={classes.titleIcon}/>}
				cancelText="CANCELAR"
				onSave={handleBlockContact}
				saveText="CONFIRMAR"
				dialogTitleClassName={classes.title}
			>
				<Grid
					container
					direction="column"
					spacing={2}
				>
					<Grid
						item
						xs={12}
					>
						<Typography>
							Ao bloquear este contato, ele será removido permanentemente de várias áreas da plataforma. Isso significa que:
						</Typography>
					</Grid>
					<Grid
						item
						xs={12}
					>
						<Grid
							container
							spacing={2}
						>
							{BLOCK_CONTACT_WARNINGS.map((warnings, index) => (
								<Grid
									key={index}
									item
									xs={12}
								>
									<Grid
										container
										alignItems="center"
										spacing={1}
									>
										<Grid
											item
										>
											<Grid
												container
												alignItems="flex-start"
											>
												<CloseIcon
													style={{
														width: 24,
														height: 24,
														fill: colors.red[400]
													}}
												/>
											</Grid>
										</Grid>
										<Grid
											item
										>
											<Typography
												variant="h4"
											>
												{warnings}
											</Typography>
										</Grid>
									</Grid>
								</Grid>
							))}
							<Grid
								item
								xs={12}
							>
								<Grid
									container
									spacing={1}
								>
									<Grid
										item
									>
										<Grid
											container
											alignItems="flex-start"
										>
											<CheckBoxIcon
												style={{
													width: 24,
													height: 24,
													fill: colors.green[500]
												}}
											/>
										</Grid>
									</Grid>
									<Grid
										item
										xs={10}
									>
										<Typography
											variant="h4"
										>
                                            Os históricos (Envio em Massa, Integração, Entrantes, Webhook e Atendimentos) serão mantidos.
										</Typography>
									</Grid>
								</Grid>
							</Grid>
						</Grid>
					</Grid>
					<Grid
						item
						xs={12}
					>
						<Typography>
                            Tem certeza de que deseja continuar?
						</Typography>
					</Grid>
				</Grid>
			</ActionDialog>
		</>
	)
}

export default BlockContactDialog
